<template>
  <div>
    <div class="vx-row" id="formulation_qa_table">
      <div class="vx-col w-full">
        <vx-card title="QC Test" class="mb-3">
          <template slot="actions">
            <vs-button v-if="$canAll(qcTestPermissions)"
                       @click="onClickCreateQcTest" class="mr-0" color="primary" size="small" type="filled">
              Create
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table noDataText="No qc tests available" :data="formulation_q_c_tests" :sst="true"
                      stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th class="__table-heading-small font-bold" width="10%">DATE/TIME</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10%">FLASH POINT (°C)</vs-th>
                <vs-th v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small font-bold" width="10%">REFRACTIVE INDEX</vs-th>
                <vs-th v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small font-bold" width="10%">SPECIFIC GRAVITY</vs-th>
                <vs-th v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small font-bold" width="10%">PH VALUE</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10%">APPEARANCE</vs-th>
                <vs-th class="__table-heading-small font-bold" width="5%">ODOUR</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10%">TASTE</vs-th>
                <vs-th class="__table-heading-small font-bold" width="5%">BRIX</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10%">NOTES</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10%">DONE BY</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10">UPDATED BY</vs-th>
                <vs-th class="__table-heading-small font-bold" width="10">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="__table-heading-small" :data="data[indextr].created_at">
                    {{data[indextr].created_at }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].flash_point">
                    {{ data[indextr].flash_point || 'N/A' }}
                  </vs-td>

                  <vs-td v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small" :data="data[indextr].refractive_index">
                    {{ data[indextr].refractive_index || 'N/A' }}
                  </vs-td>

                  <vs-td v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small" :data="data[indextr].specific_gravity">
                    {{ data[indextr].specific_gravity  || 'N/A' }}
                  </vs-td>

                  <vs-td v-if="formulation.formulation_type === 'liquid'" class="__table-heading-small" :data="data[indextr].ph">
                    {{ data[indextr].ph || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].appearance">
                    {{ data[indextr].appearance || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].odour">
                    {{ data[indextr].odour || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].taste">
                    {{ data[indextr].taste || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].brix">
                    {{ data[indextr].brix || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].notes">
                    {{ data[indextr].notes || 'N/A' }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].done_by">
                    {{ data[indextr].done_by }}
                  </vs-td>

                  <vs-td class="__table-heading-small" :data="data[indextr].updated_by">
                    {{ data[indextr].updated_by }}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row" v-if="$canAll(qcTestPermissions)">

                      <vx-tooltip text="Update" position="top">
                        <vs-button @click="onClickUpdateQcTest(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather"
                                   icon="icon-edit"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
    <qc-test-create-formulation-pop-up v-bind:type="formulation ? formulation.formulation_type : ''"
                                       ref="qcTestCreateFormulationPopUp"/>
    <qc-test-update-formulation-pop-up v-bind:type="formulation ? formulation.formulation_type : ''"
                                       ref="qcTestUpdateFormulationPopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import QcTestCreateFormulationPopUp from '@/components/popups/formulations/qc-test/QcTestCreateFormulationPopUp'
import QcTestUpdateFormulationPopUp from '@/components/popups/formulations/qc-test/QcTestUpdateFormulationPopUp'

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
  name: "FormulationQcTestTab",
  components: {
    QcTestCreateFormulationPopUp,
    QcTestUpdateFormulationPopUp
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      formulationId: '',
      formulation_q_c_tests: []
    }
  },
  methods: {
    async refreshData() {
      this.$emit('refreshGeneral')
    },
    async onClickCreateQcTest() {
      await this.$refs.qcTestCreateFormulationPopUp.openPopup(this.formulationId, this.formulation.qa_status_id, this.formulation.q_c_quide)
    },
    async onClickUpdateQcTest(test_id) {
      await this.$refs.qcTestUpdateFormulationPopUp.openPopup(test_id)
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    this.formulation_q_c_tests = this.formulation.formulation_q_c_tests
  },
  computed: {
    formulation: function () {
      return this.formulation_data
    },
    qcTestPermissions: function () {
      return this.formulationPermissions.concat(['qc-elements-edit'])
    },
  },
  watch: {
    formulation_data: {
      deep: true,
      handler() {
        this.formulation_q_c_tests = this.formulation.formulation_q_c_tests
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
